import {createSelector} from 'reselect';
import {isMobile} from './DeviceSelectors';
import {isCollapsibleExperiment} from './ExperimentSelectors';
import isLastStep from './isLastStepSelector';

export default createSelector(
  [isMobile, isCollapsibleExperiment, isLastStep],
  (mobile, collapsibleExperiment, lastStep) => (!mobile && !collapsibleExperiment) || lastStep,
);
